// extracted by css-extract-rspack-plugin
export default {"popoverTrigger":"Fr9tNhgYgqMeGAui__popoverTrigger___","cellPopoverList":"VSIu6VXWMOs1G9Cr__cellPopoverList___"};